import React from "react";
import { Row, Col } from "antd";

function HelpCenter() {
  return (
    <div className="section pt-[80px] pb-[80px]">
      <div className="container">
        {/* Header */}
        <Row>
          <Col md={24} xs={24}>
            <div className="text-center mb-[60px]">
              <h1 className="text-[32px] md:text-[48px] font-bold text-black font-custom mb-4">
                Help Center
              </h1>
              <p className="text-[#72747C] text-[16px] md:text-[18px] font-custom">
                Find answers to your questions and get support
              </p>
            </div>
          </Col>
        </Row>

        {/* FAQ Section */}
        <section className="mb-[60px]">
          <h2 className="text-[24px] md:text-[32px] font-semibold mb-[25px] text-[#333] font-custom">
            Frequently Asked Questions
          </h2>

          <Row gutter={[20, 20]}>
            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  How do I place an order?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Simply browse products, add them to your cart, and proceed to checkout.
                </p>
              </div>
            </Col>

            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  Can I cancel or change my order?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Orders can be canceled or updated within 24 hours of placing them.
                </p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Orders & Shipping */}
        <section className="mb-[60px]">
          <h2 className="text-[24px] md:text-[32px] font-semibold mb-[25px] text-[#333] font-custom">
            Orders & Shipping
          </h2>

          <Row gutter={[20, 20]}>
            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  How long does shipping take?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Delivery usually takes 3–7 business days.
                </p>
              </div>
            </Col>

            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  Do you offer international shipping?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Yes, international shipping is available with additional charges.
                </p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Returns */}
        <section className="mb-[60px]">
          <h2 className="text-[24px] md:text-[32px] font-semibold mb-[25px] text-[#333] font-custom">
            Returns & Refunds
          </h2>

          <Row gutter={[20, 20]}>
            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  What is your return policy?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Products can be returned within 7 days if unused and in original packaging.
                </p>
              </div>
            </Col>

            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  When will I receive my refund?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Refunds are processed within 5–10 business days.
                </p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Payment */}
        <section className="mb-[60px]">
          <h2 className="text-[24px] md:text-[32px] font-semibold mb-[25px] text-[#333] font-custom">
            Payments
          </h2>

          <Row gutter={[20, 20]}>
            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-white hover:shadow-lg hover:-translate-y-[2px] transition-all duration-300">
                <h4 className="font-medium text-[18px] md:text-[20px] text-black font-custom mb-3">
                  What payment methods do you accept?
                </h4>
                <p className="text-[#666] text-[14px] md:text-[16px] leading-[1.6] font-custom">
                  Credit/Debit Cards, UPI, Net Banking, and Cash on Delivery.
                </p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Contact */}
        <section>
          <h2 className="text-[24px] md:text-[32px] font-semibold mb-[25px] text-[#333] font-custom">
            Contact Support
          </h2>

          <Row gutter={[20, 20]}>
            <Col md={24} xs={24}>
              <div className="p-[20px] md:p-[30px] border border-[#e0e0e0] rounded-lg bg-[#f9f9f9]">
                <p className="text-[#333] text-[14px] md:text-[16px] font-custom mb-4 font-medium">
                  Still need help? Contact our support team:
                </p>
                <ul className="text-[#333] text-[14px] md:text-[16px] space-y-2 font-custom list-none p-0">
                  <li>Email: support@ecommerce.com</li>
                  <li>Phone: +1 234 567 890</li>
                  <li>Hours: Mon – Fri, 9 AM – 6 PM</li>
                </ul>
              </div>
            </Col>
          </Row>
        </section>
      </div>
    </div>
  );
}

export default HelpCenter;